import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

const RESERVED_MARKET_PATHS = new Set(["plan", "strategy", "guidance", "pressure", "scenario", "admin"]);

// Preserve list context from an office return or an old record bookmark, but
// never turn an arbitrary external return target into an internal redirect.
export function marketDrawerRedirect({ marketId, recordTab, search = "", hash = "", state }) {
  const fallback = "/places/markets";
  if (!marketId || RESERVED_MARKET_PATHS.has(marketId)) return fallback;
  const returnPath = state?.returnPath;
  const context = typeof returnPath === "string" && /^\/places\/markets(?:[?#]|$)/.test(returnPath)
    ? new URL(returnPath, "https://local.invalid") : null;
  const params = new URLSearchParams(context?.search ?? "");
  for (const [key, value] of new URLSearchParams(search)) params.set(key, value);
  params.delete("expandMarket");
  params.delete("market");
  params.set("peek", marketId);
  if (["pressure", "scenario", "capacity"].includes(recordTab)) params.set("peekTab", "capacity");
  else if (recordTab === "plan" || recordTab === "media") params.set("peekTab", recordTab);
  else params.delete("peekTab");
  return `${fallback}?${params}${hash || context?.hash || ""}`;
}

export function MarketRecordRedirect() {
  const { marketId, recordTab } = useParams();
  const location = useLocation();
  return <Navigate to={marketDrawerRedirect({ marketId, recordTab, ...location })}
    state={location.state} replace />;
}
